module.exports = __webpack_public_path__ + "img/icon-chapters.f791c29c.png";